import React, {Component} from 'react';
import BirthDateResourceType from './../../types/BirthDateResourceType';
import { ThemeProvider } from "styled-components";
import YearPicker from './YearPicker';
import * as moment from 'moment';

import * as Datetime from 'react-datetime';
import Select from 'react-select';

/**
 * Birth Date Input component
 */
class BirthDateInput extends Component {

  calendarWidth = null;
  daySize = 0;

  getCalendarWidth() {
    let parent = document.getElementsByClassName("nppe2-fc-birth-date-input");
    if (parent[0]){
      this.calendarWidth = parent[0].offsetWidth;
      // (calendar width - padding - border) / 7 days
      this.daySize = (this.calendarWidth - 64 - 8) / 7;
    }
  }

  componentDidMount() {
    this.getCalendarWidth();
    window.addEventListener("resize", this.getCalendarWidth.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.getCalendarWidth.bind(this));
  }

  /**
   * Scrolls the input into focus on mobile devices
   *
   * @memberof BirthDateInput
   */
  shouldScrolltoView() {
    const windowWidth = window.innerWidth;
    if (windowWidth <= 420){
      const scrollToElement = document.getElementsByClassName("nppe2-fc-birth-date-input");
      if (scrollToElement && scrollToElement.length > 0){
        scrollToElement[0].scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  }

  /**
   * Creates the data structure for the months drop down
   **/
  buildMonths() {
    let data = [];
    for (let i = 0; i <= 11; i++){
      data.push({
        value: i,
        label: i,
        listOrder: i
      });
    }
    return data;
  }

  /**
   * Creates the data structure for the months drop down
   **/
  buildYears() {
    let data = [];
    for (let i = 0; i <= 25; i++){
      data.push({
        value: i,
        label: i,
        listOrder: i
      });
    }
    return data;
  }

  calculateBirthDate(years, months) {
    if (isNaN(years)){
      years = 0;
    }
    if (isNaN(months)){
      months = 0;
    }
    let birthDate = moment().subtract(years, 'years').subtract(months, 'months');
    birthDate = birthDate.format("DD-MM-YYYY");

    return birthDate;
  }

  render() {
    const { label, dateFormat, years, months, dropdownLabel, noOptionsMsg } = this.props.data;
    const { onSelect, onSetYear, onSetMonth, selected, hideSelector, showSelector,
      visible, toggleVisibility, onDateChange, selectedYears, selectedMonths } = this.props;
    const inputProps = {
      readonly: "readonly",
      placeholder: dateFormat,
      id: "nppe2-fc-validate-birth-date",
    };

    const selectMonths = this.buildMonths();
    const selectYears = this.buildYears();

    const dropDownStyle = {
      option: (provided, state) => ( () => {
        return {
          ...provided,
          color: state.isSelected ? '#ea6b6a' : '#333',
          background: state.isSelected ? '#ea6b6a' : 'white',
        }
      }),
    }

    return (
      <div className="nppe2-fc-birth-date-input">
        <div className="nppe2-fc-birth-date__wrapper">

          <div className="row">

            <div className="col-md-6">
              <div className="nppe2-fc-birth-date__year">
                <div className="nppe2-fc-sub-title">
                  {years}
                </div>

                <Select
                  options={selectYears}
                  className="nppe2-fc-react-select"
                  name="nppe2-fc-breed-switcher-select-years"
                  onChange={(selected)=>{
                    let months = parseInt(document.getElementsByName("nppe2-fc-breed-switcher-select-months")[0].value);
                    let years = parseInt(selected.value);
                    let birthDate = this.calculateBirthDate(years, months);
                    this.props.onSetYear(years);
                    this.props.onDateChange(birthDate);
                  }}
                  styles={dropDownStyle}
                  placeholder={dropdownLabel}
                  aria-label={years}
                  value={(selectedYears !== null) ? selectedYears[selectedYears] : null}
                  noOptionsMessage={() => noOptionsMsg}
                />
              </div>
            </div>

            <div className="col-md-6">
              <div className="nppe2-fc-birth-date__month">
                <div className="nppe2-fc-sub-title">
                  {months}
                </div>

                <Select
                  options={selectMonths}
                  className="nppe2-fc-react-select"
                  name="nppe2-fc-breed-switcher-select-months"
                  onChange={(selected)=>{
                    let months = parseInt(selected.value);
                    let years = parseInt(document.getElementsByName("nppe2-fc-breed-switcher-select-years")[0].value);
                    let birthDate = this.calculateBirthDate(years, months)
                    this.props.onSetMonth(months);
                    this.props.onDateChange(birthDate);
                  }}
                  styles={dropDownStyle}
                  placeholder={dropdownLabel}
                  aria-label={months}
                  value={(selectedMonths !== null) ? selectedMonths[selectedMonths] : null}
                  noOptionsMessage={() => noOptionsMsg}
                />
              </div>
            </div>
          </div>

        </div>

      </div>
    );
  }
};

BirthDateInput.propTypes = BirthDateResourceType;

export default BirthDateInput;
